module.exports = __webpack_public_path__ + "img/sj.b884cec9.svg";